module.exports = __webpack_public_path__ + "static/media/icon_111.eb91e3d7.svg";